import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';
import classnames from 'classnames';

import { POPOVER_FLYOUT, POPOVER_TOOLTIP } from './constants';

import styles from './interactable-popover.module.less';

/**
 * @typedef {import('ui-components/components/button').ButtonClickHandler} ButtonClickHandler
 */

/**
 * @param {object} props
 * @param {boolean} props.hideTooltipTitle
 * @param {ButtonClickHandler} props.onClose
 * @param {'tooltip'|'flyout'} props.popoverType
 * @param {boolean} props.isDark
 * @param {JSX.Element} props.title
 * @returns {JSX.Element|null}
 */
export const ContentHeader = ({ hideTooltipTitle, onClose, popoverType, isDark, title }) => {
  const shouldShowCloseButton = popoverType === POPOVER_FLYOUT;

  if (hideTooltipTitle && popoverType === POPOVER_TOOLTIP) {
    return null;
  }

  return (
    <div
      className={classnames(styles['popover-header'], {
        [styles['popover-header-background']]: isDark,
      })}
    >
      <div
        className={classnames(styles['popover-title'], {
          [styles.dark]: isDark,
        })}
      >
        {title}
      </div>
      {shouldShowCloseButton && (
        <button className={classnames('unstyled-button', styles['popover-close-button'])} onClick={onClose}>
          <FontAwesomeIcon icon={faXmark} />
        </button>
      )}
    </div>
  );
};
